export interface DocProperties {
  title: string
  subject: string
  keywords: string
  comments: string
  author: string
  lastAuthor: string
  category: string
  manager: string
  company: string
  revisionNumber: string
  url: string
}

const DOC_PROPERTY_FIELDS: (keyof DocProperties)[] = [
  'title',
  'subject',
  'keywords',
  'comments',
  'author',
  'lastAuthor',
  'category',
  'manager',
  'company',
  'revisionNumber',
  'url',
]

export async function getDocProperties(): Promise<DocProperties> {
  return Word.run(async (context) => {
    const props = context.document.properties
    props.load(DOC_PROPERTY_FIELDS)
    await context.sync()

    const result: DocProperties = {
      title: props.title || '',
      subject: props.subject || '',
      keywords: props.keywords || '',
      comments: props.comments || '',
      author: props.author || '',
      lastAuthor: props.lastAuthor || '',
      category: props.category || '',
      manager: props.manager || '',
      company: props.company || '',
      revisionNumber: props.revisionNumber || '',
      url: (props as any).url || '',
    }
    return result
  })
}

export async function getDocProperty<K extends keyof DocProperties>(
  key: K,
): Promise<DocProperties[K]> {
  return Word.run(async (context) => {
    const props = context.document.properties
    props.load([key])
    await context.sync()
    return ((props as any)[key] || '') as DocProperties[K]
  })
}

export async function setDocProperty<K extends keyof DocProperties>(
  key: K,
  value: DocProperties[K],
): Promise<void> {
  return Word.run(async (context) => {
    const props = context.document.properties
    props.load([key])
      ; (props as any)[key] = value
    await context.sync()
  })
}
